module.exports = __webpack_public_path__ + "static/media/contract_active.563b9bbf.svg";